var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"social-btn vk-btn",style:(_vm.loginButtonStyles),attrs:{"href":_vm.href}},[_c('i',{directives:[{name:"show",rawName:"v-show",value:(_vm.baseData.branding.iconVisible),expression:"baseData.branding.iconVisible"}],staticClass:"fa fa-vk"}),_vm._v(" "),_c('span',{domProps:{"textContent":_vm._s(_vm.$t('vkontakte'))}})])
}
var staticRenderFns = []

export { render, staticRenderFns }